module.exports = __webpack_public_path__ + "img/img.ea90e62b.svg";